module.exports = __webpack_public_path__ + "static/media/person-1.5330376f.jpg";